/* eslint-disable react/jsx-curly-brace-presence */
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { Nav, NavItem, NavLink } from "reactstrap";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import logo from "../../../assets/images/logo.png";
import logoReducido from "../../../assets/images/logo-reducido.png";
import useFetcher from "../../../hooks/useFetcher";
import { useAuth } from "../../../context/AuthContext";
import modulos from "../../../mocks/modulos";
import SubMenu from "./SubMenu";

const SidebarContainer = styled.div`
  width: ${({ isExpanded }) => (isExpanded ? "200px" : "70px")};
  height: 100vh;
  background-color: #062541;
  transition: width 0.3s ease;
  border-radius: 0 8px 8px 0;
  position: fixed;
  top: 0;
  left: 0;
  overflow: hidden;
  z-index: 9999;
  font-family: "Nunito";

  a {
    color: #fff !important;
    margin-bottom: 10px !important;
    display: flex;
  }
`;

const SidebarV2 = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { getUserAccess, linkToken, currentUser } = useAuth();
  const isAudit = currentUser.haveAuditAccess(modulos.TICKETING);

  if (linkToken) {
    return null;
  }
  const [userAccess, isLoadingAccess] = useFetcher(getUserAccess);
  const centralized = userAccess && userAccess[0] && userAccess[0].metadata && JSON.parse(userAccess[0].metadata.replace(/<[^>]*>/g, "")).centralized;
  useEffect(() => {
    if (!userAccess) useHistory().push("/login");
  }, [userAccess]);

  return (
    <SidebarContainer isExpanded={isExpanded} onMouseEnter={() => setIsExpanded(true)} onMouseLeave={() => setIsExpanded(false)}>
      <div className="mb-5" style={{ height: "70px", display: "flex", justifyContent: "center", alignItems: "center" }}>
        {isExpanded ? (
          <img className="logo-adecco lazyloaded" src={logo} alt="" width="130px" height="80px" />
        ) : (
          <img className="logo-adecco lazyloaded" src={logoReducido} alt="" width="25px" height="25px" />
        )}
      </div>
      <Nav vertical className="list-unstyled pb-3 sidebar-menu">
        {userAccess && !isLoadingAccess ? (
          userAccess.map((access) =>
            access.menu.items ? (
              <SubMenu title={access.menu.text} key={access.id} icon={["fas", access.menu.icon]} path={access.menu.path} isExpanded={isExpanded}>
                {access.menu.items
                  .reduce((acc, el) => {
                    if (!centralized && el.icon !== "user-plus" && (!isAudit || el.icon !== "user")) {
                      acc.push(el);
                    }

                    if (centralized && (!isAudit || el.icon !== "user")) {
                      acc.push(el);
                    }
                    return acc;
                  }, [])
                  .map((item, i) => (
                    <NavItem key={`${access.id}_${i + 1}`} className={`${isExpanded ? "ml-3" : "mx-auto"}`}>
                      <NavLink tag={Link} to={item.path} className={item.path === "/notasdepedido" ? "first-step" : ""}>
                        <FontAwesomeIcon icon={["fas", item.icon]} className={`${isExpanded ? "mr-2" : "ml-4"}`} size="md" />
                        {isExpanded && item.text}
                      </NavLink>
                    </NavItem>
                  ))}
              </SubMenu>
            ) : (
              <NavItem key={access.id}>
                <NavLink tag={Link} to={access.menu.path === "/clientes" ? "/clientes?page=1&perpage=10" : access.menu.path}>
                  <FontAwesomeIcon icon={["fas", access.menu.icon]} className={`${isExpanded ? "mr-2" : "mx-auto"}`} size="lg" />
                  {isExpanded && access.menu.text}
                </NavLink>
              </NavItem>
            )
          )
        ) : (
          <></>
        )}
      </Nav>
      <div style={{ position: "fixed", bottom: "0", width: isExpanded ? "200px" : "70px" }}>
        {isExpanded ? <p className="text-center text-white">Versión 2.1.0</p> : <p className="text-center text-white">v2.1.0</p>}
      </div>
    </SidebarContainer>
  );
};

export default SidebarV2;
